export const productLists = [
  {
    name: "Vitra .03 chair black W44*D52*H79 SH42 cm",
    price: 300000,
    image: "1630652431593.jpeg",
  },
  {
    name: "Cuba chair white W43*D49*H73.5 cm SH44 cm",
    price: 300000,
    discount: 50,
    image: "1630652431594.jpeg",
  },
  {
    name: "Cuba chair black W43*D49*H73.5 cm SH44 cm",
    price: 250000,
    image: "1630652431595.jpeg",
  },
  {
    name: "Jo chair white W50*D56*H85.5 cm SH45 cm",
    price: 250000,
    image: "1630652431596.jpeg",
  },
  {
    name: "Nancy chair white W51*D52.5*H82 SH45 cm",
    price: 250000,
    image: "1630652431597.jpeg",
  },
  {
    name: "Dallas upholstered chair black W44*D59*H94.5 cm SH48 cm",
    price: 250000,
    image: "1630652431598.jpeg",
  },
  {
    name: "Hawaii upholstered chair blue W44*D53*H97 cm SH48 cm",
    price: 250000,
    image: "1630652431599.jpeg",
  },
  {
    name: "Hawaii upholstered chair with letter tray",
    price: 250000,
    discount: 25,
    image: "1630652431510.jpeg",
  },
  {
    name: "Folding chair with chrom-plated frame black",
    price: 250000,
    image: "1630652431511.jpeg",
  },
  {
    name: "Florence chair with chrome-plated frame black W55*D52*H80 cm",
    price: 250000,
    image: "1630652431512.jpeg",
  },
  {
    name: "Sledchair Chairik black with writing table and seat cushion",
    price: 250000,
    image: "1630652431513.jpeg",
  },
  {
    name: "Chair Skool W43 SH45 cm",
    price: 250000,
    image: "1630652431514.jpeg",
  },
  // {
  //   name: "Torino wooden chair with stretch cover white",
  //   price: 456000,
  //   image: "1630652431515.jpeg",
  // },
  // {
  //   name: "Torino wooden chair with stretch cover red",
  //   price: 456000,
  //   image: "1630652431516.jpeg",
  // },
  // {
  //   name: "Dallas upholstered chair with suede cover taupe",
  //   price: 456000,
  //   image: "1630652431517.jpeg",
  // },
  // {
  //   name: "Dallas upholstered chair with suede cover black",
  //   price: 456000,
  //   image: "1630652431518.jpeg",
  // },
  // {
  //   name: "Spielberg wooden folding chair cream W56*D56*H91 cm SH46 cm",
  //   price: 250000,
  //   image: "1630652431519.jpeg",
  // },
  // {
  //   name: "Milano wooden chair with fabric seat blue",
  //   price: 250000,
  //   image: "1630652431520.jpeg",
  // },
];
